import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GoogleCallbackPage } from '@/features/auth';

function GoogleCallback() {
  const { code, state, error, dev } = Route.useSearch();
  return <GoogleCallbackPage code={code} state={state} error={error} dev={dev === '1'} />;
}

/**
 * Google returns the browser here with `code` and `state`. No session redirect: finishing the
 * exchange replaces the session cookie.
 */
export const Route = createFileRoute('/(public)/auth/google/callback')({
  validateSearch: z.object({
    code: z.string().optional(),
    state: z.string().optional(),
    error: z.string().optional(),
    dev: z.string().optional(),
  }),
  component: GoogleCallback,
});
